export function NumberBadge({ selectedCategory, itemCount }) {

    return (
        <span className="badge badge-secondary mx-1 pt-1 bg-white c-darkOrange">
            {selectedCategory === "" || selectedCategory === null ? itemCount : ""}
        </span>
    )
}

export function NumberBadgeItems({ selectedCategory, itemCount, category }) {

    return (
        <span className="badge badge-secondary mx-1 pt-1 bg-white c-darkOrange">
            {selectedCategory === category ? itemCount : ""}
        </span>
    )
}

export function CountBadge({ itemCount }) {
    return (
        <span className="badge badge-secondary mx-1 pt-1 bg-white c-darkOrange">
            {itemCount}
        </span>
    )
}
export function NotifiBadge() {
    return (
        <span className="position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle">
        </span>
    )
}